// extracted by mini-css-extract-plugin
module.exports = {"arrow":"_3VTS_","wrapper":"_2GUTW","active":"_2RwMF","page":"_1fg4R","disabled":"_164DM"};